/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unescaped-entities */
import { Flex, Text } from '@baont0209/pibridge_uikit_v20';
import { IsOpenPhisingWaringContext } from 'components/Menu';
import { Alert, CloseIcon, PhisingWarningSvg } from 'components/Pancake-uikit';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

interface PhisingWarningProps {
    handleOpenPhisingWarning: any
    isOpen: boolean
}

const PhisingWarning = ({handleOpenPhisingWarning, isOpen, ...props}: PhisingWarningProps) => {
    const [isMobile, setIsMobile] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [zoom, setZoom] = useState(1);
  

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
      };

    const handleZoom = () => {
    if (scrollPosition >= 2000 && handleScroll) {
        setZoom(zoom - 0.001);
    }
    };

    useEffect(() => {
        if (window.screen.width <= 680) {
            return setIsMobile(true);
        } return setIsMobile(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.screen.width])

    return (
         <>
             { isOpen && 
                (   
                    <Warning>
                            <CsFlex isMobile={isMobile}>
                                <CsText><Link href='https://PiBridge.org' target='_blank'>PHISHING WARNING: please make sure you're visiting https://PiBridge.org - check the URL carefully.</Link></CsText>
                                <FlexIcon justifyContent='flex-end'>  
                                    <CsCloseIcon onClick={handleOpenPhisingWarning}/>
                                </FlexIcon>
                            </CsFlex>
                    </Warning>
                )
            }
         </>
    );
};

export default PhisingWarning;

const Warning = styled(Flex)`

    /* position: absolute; */
    /* top: 100px; */
    left: 0px;
    width: 100%;
    height: 100%;
    justify-content: center;
    padding: 0px 50px;
    @media screen and (max-width: 1024px){
        top: 70px;
    }
    @media screen and (max-width: 768px){
        padding: 0px 20px;
    }
    @media screen and (max-width: 680px){
        /* margin-top: 25px; */
    }

    @media screen and (max-width: 600px){
        height: 100px;
        padding: 0px 10px;
    }

`

const CsFlex = styled(Flex)<{isMobile: boolean}>`
    background: url('./images/ImgPi/PhisingWarning.png');
    background: ${({isMobile}) => isMobile ? `url('./images/ImgPi/PhisingWarning680.png')` : `url('./images/ImgPi/PhisingWarning2560.png')`};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
    position: relative;

    @media screen and (min-width: 2000px){
       width: 1600px;
    }
    @media screen and (max-width: 850px){
        padding: 0px 30px;
        background-size: 100% 85%;
    }

    @media screen and (max-width: 680px){
        padding: 0px 30px;
        background-size: 100% 80%;
    }
    @media screen and (max-width: 600px){
        padding: 0px 10px;
        background-size: 100% 90%;
    }

    align-items: center;
    justify-content: space-around;
    z-index: 100;
`


const CsText = styled(Text)`
    margin-bottom: 26px;
    font-weight: 400;
    font-size: 22px;
    line-height: 38px;
    @media screen and (max-width: 1280px){
        font-size: 18px;
        margin-bottom: 10px;
    }
    @media screen and (max-width: 1024px){
        font-size: 15px;
        margin-bottom: 10px;
    }
    @media screen and (max-width: 850px){
        margin-bottom: 20px;
    }
    @media screen and (max-width: 768px){
        font-size: 13px;
        margin-bottom: 10px;
    }
    @media screen and (max-width: 680px){
        margin-bottom: 20px;
        line-height: 20px;
    }
    @media screen and (max-width: 600px){
        font-size: 12px;
        text-align: center;
        /* padding-left: 20px; */
        margin-bottom: 20px;
    }
    @media screen and (max-width: 350px){
        font-size: 10px;
        line-height: 20px;
        padding-left: 10px;
    }
    @media screen and (min-width: 1900px){
        font-size: 27px;
    }
`
const CsCloseIcon = styled(CloseIcon)`
    margin-bottom: 20px;
    cursor: pointer;
    width: 25px;
    &:hover {
        fill: red;
    }
    @media screen and (min-width: 1900px){
        width: 35px;
    }
    @media screen and (max-width: 768px){
        margin-bottom: 10px;
    }
    @media screen and (max-width: 680px) {
        /* margin-right: 20px; */
        margin-bottom: 20px;
        width: 20px;
    }
    @media screen and (max-width: 426px) {
        /* margin-right: 10px; */
        margin-bottom: 20px;
    }
    @media screen and (max-width: 320px) {
        /* margin-right: 10px; */
        margin-bottom: 20px;
    }
`

const Link = styled.a`
  &:hover {
    color: blue;
  }
`

const FlexIcon = styled(Flex)`
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
 @media screen and (max-width: 600px) {
    right: 0px;
    top: 30px;
    padding-right: 12px;
 }
 @media screen and (max-width: 430px) {
    padding-right: 8px;
 }
 @media screen and (max-width: 350px) {
    padding-right: 5px;
 }
`